// ContactCard — German. 'Edit', 'Save', 'Cancel', 'Saving…', 'not set' and 'not collected' live
// in common.de.ts and are not repeated. 'tier', 'cadence', 'do not contact' and the three
// principal words are PersonPage's too — the same German, so the duplicate is silent; 'read',
// 'declared', 'estimated', 'computed', 'confidence' are the method words ReviewPage, SignalsZone
// and ProfileZone already speak, byte-identical here so this card reads German on its own.
//
// The cell names (Work e-mail, Canton of work, Register …) and every token (a canton, Sie/Du, a
// language) come from `src/shared/person-raster.v1.ts` through `personLabelFor`, never from here.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Contact': 'Kontakt',
  'the person’s own columns and the raster’s contact cells · an edit writes a declared fact':
    'die eigenen Spalten der Person und die Kontaktzellen des Rasters · eine Änderung schreibt einen erklärten Sachverhalt',
  'Ask Surfe': 'Surfe fragen',
  'Asking…': 'Frage an…',
  'Ask Surfe for the professional e-mail — one credit; the answer is a proposal you hold or refuse.':
    'Surfe nach der geschäftlichen E-Mail fragen — ein Credit; die Antwort ist ein Vorschlag, den Sie übernehmen oder ablehnen.',
  'This person asked not to be contacted; nothing is bought about them.': 'Diese Person will nicht kontaktiert werden; über sie wird nichts gekauft.',
  'e-mail credits left': 'E-Mail-Credits übrig',
  'a broker’s assertion waits for your click; it is never held on arrival': 'die Behauptung eines Datenhändlers wartet auf Ihren Klick; sie wird nie bei Eingang übernommen',
  'waits in Review': 'wartet in der Prüfung',
  'Surfe says': 'Surfe sagt',
  'more cells filed beside it': 'weitere Zellen daneben eingereicht',
  'cells filed from the answer': 'Zellen aus der Antwort eingereicht',
  'Paid Surfe enrichment is off (setting surfe.email_enrichment); nothing was bought.': 'Die bezahlte Surfe-Anreicherung ist aus (Einstellung surfe.email_enrichment); nichts wurde gekauft.',
  'Surfe has no e-mail credits left; nothing was bought.': 'Surfe hat keine E-Mail-Credits mehr; nichts wurde gekauft.',
  'Surfe refused the call (HTTP {n}); nothing was bought.': 'Surfe hat den Aufruf abgelehnt (HTTP {n}); nichts wurde gekauft.',
  'Surfe could not be reached; nothing was bought.': 'Surfe war nicht erreichbar; nichts wurde gekauft.',
  'Surfe answered an error (HTTP {n}); nothing was bought.': 'Surfe hat mit einem Fehler geantwortet (HTTP {n}); nichts wurde gekauft.',
  'No held current employer — Surfe is asked only about a person whose employer is on the record.': 'Kein übernommener aktueller Arbeitgeber — Surfe wird nur zu Personen gefragt, deren Arbeitgeber im Register steht.',
  'A work e-mail is already held; nothing was asked.': 'Eine geschäftliche E-Mail ist bereits übernommen; nichts wurde gefragt.',
  'Neither a LinkedIn URL nor a last name with an employer domain: Surfe cannot identify them.': 'Weder eine LinkedIn-URL noch ein Nachname mit Arbeitgeber-Domain: Surfe kann die Person nicht identifizieren.',
  'Surfe knows no professional e-mail for this person; the answer is kept as a snapshot.': 'Surfe kennt keine geschäftliche E-Mail dieser Person; die Antwort ist als Momentaufnahme abgelegt.',
  'Surfe is still working; nothing was filed yet.': 'Surfe arbeitet noch; nichts wurde bisher eingereicht.',
  'Surfe could not enrich this person; the call is on the ledger.': 'Surfe konnte diese Person nicht anreichern; der Aufruf steht im Journal.',

  // the marks a column-only value takes
  'typed by the operator; no fact on the cell yet': 'von der Operatorin eingetragen; noch kein Sachverhalt auf der Zelle',
  'written by an import; nobody has held it': 'von einem Import geschrieben; niemand hat es übernommen',
  // a CURRENT fact that nobody confirmed: ◇ auf dem Wert, das Wort daneben
  'not held': 'nicht übernommen',
  'a fact on the cell that nobody has held': 'ein Sachverhalt auf der Zelle, den niemand übernommen hat',
  'column': 'Spalte',
  'operator': 'Operatorin',
  'agent': 'Agent',
  'import': 'Import',

  // the methods
  'read': 'Lesung',
  'declared': 'erklärt',
  'estimated': 'geschätzt',
  'computed': 'berechnet',
  'confidence': 'Konfidenz',
  'setting': 'Einstellung',

  // the reach rows
  'Type one or more addresses; the first is the work e-mail the raster holds. Clearing retracts.':
    'Eine oder mehrere Adressen eintragen; die erste ist die geschäftliche E-Mail, die das Raster hält. Leeren zieht zurück.',
  'one or more addresses, comma-separated': 'eine oder mehrere Adressen, durch Komma getrennt',
  'Type one or more numbers; the first is the work phone the raster holds. Clearing retracts.':
    'Eine oder mehrere Nummern eintragen; die erste ist die geschäftliche Nummer, die das Raster hält. Leeren zieht zurück.',
  'one or more numbers, comma-separated': 'eine oder mehrere Nummern, durch Komma getrennt',
  'Paste the profile URL — linkedin.com/in/…; the profile itself is never read.':
    'Die Profil-URL einfügen — linkedin.com/in/…; das Profil selbst wird nie gelesen.',
  'The canton is read by a run or computed from the employer; there is no column to type into.':
    'Der Kanton wird von einem Lauf gelesen oder aus dem Arbeitgeber berechnet; es gibt keine Spalte zum Eintragen.',
  'The commune of the person’s place of work, as the source spells it — not a domicile. Clearing retracts.':
    'Die Gemeinde des Arbeitsorts, wie die Quelle sie schreibt — kein Wohnort. Leeren zieht zurück.',
  'the commune as the source spells it': 'die Gemeinde, wie die Quelle sie schreibt',
  'Clearing a field retracts the claim; the record keeps its history.':
    'Ein geleertes Feld zieht die Aussage zurück; der Bestand behält seine Geschichte.',

  // the settings rows
  'language': 'Sprache',
  'The language every draft to this person is written in.': 'Die Sprache, in der jeder Entwurf an diese Person geschrieben wird.',
  'Formal or informal address — the writing profile suggests, you decide.':
    'Förmliche oder vertraute Anrede — das Schreibprofil schlägt vor, Sie entscheiden.',
  'read from their own lines; nobody has held it': 'aus ihren eigenen Zeilen gelesen; niemand hat es übernommen',
  '{n} lines': '{n} Zeilen',
  'Declare': 'Erklären',
  'Declare the register the correspondence supports; every draft to them is then written in it.':
    'Die Anrede erklären, die die Korrespondenz stützt; jeder Entwurf an sie wird dann darin geschrieben.',
  'tier': 'Stufe',
  'A, B or C — how much of your attention this person gets; the cadence follows it.':
    'A, B oder C — wie viel Ihrer Aufmerksamkeit diese Person bekommt; die Taktung folgt daraus.',
  'cadence': 'Taktung',
  'Days between touches before this person counts as cooling.': 'Tage zwischen Berührungen, bevor diese Person als abkühlend gilt.',
  'do not contact': 'nicht kontaktieren',
  'Lift the block: drafts and sequences may address this person again.':
    'Die Sperre aufheben: Entwürfe und Sequenzen dürfen diese Person wieder ansprechen.',
  'Set the block: no draft and no sequence addresses this person until it is lifted.':
    'Die Sperre setzen: kein Entwurf und keine Sequenz spricht diese Person an, bis sie aufgehoben ist.',
  'Lift': 'Aufheben',
  'Set': 'Setzen',
  'yes': 'ja',
  'no': 'nein',
}, 'ContactCard');
